module.exports = __webpack_public_path__ + "static/scale-model-of-oxbow-park-in-renton-washington-54bce58a75cd6956cdaf8b63401a98ea.png";